export const sigcapAddress = "0x2096FE7F6C000c244FB6C60f2bF2B770d326d079";
